const BASE_URL = "https://psychnow.com";

export const EXTERNAL_URL = {
  USER_GUIDE: `${BASE_URL}/userguide`,
  TERMS_PATIENT: `${BASE_URL}/termsandconditions`,
  TERMS_PROVIDER: `${BASE_URL}/providerstermsandconditions`,
  PRIVACY_POLICY: `${BASE_URL}/privacypolicy`,
  BAA: `${BASE_URL}/baa`,
  FREE_TRIAL_TERMS: `${BASE_URL}/freetrialtermsandconditions`,
  PAYMENT_SETTINGS: `${BASE_URL}/userguide/payment-settings`,
} as const;
